import React from "react";
import { SpanStatusCode, trace } from "@opentelemetry/api";
import { useRouteError } from "react-router-dom";

// Interface untuk props ErrorPage
export interface ErrorPageProps {
  /** Judul halaman error (default: "Oops!") */
  title?: string;
  /** Pesan error utama (default: "Terjadi kesalahan yang tidak terduga.") */
  message?: string;
  /** Custom render function untuk menampilkan error */
  renderError?: (error: Error) => React.ReactNode;
  /** Custom CSS class untuk container */
  className?: string;
  /** Apakah menampilkan stack trace (default: false) */
  showStackTrace?: boolean;
  /** Custom action button */
  actionButton?: React.ReactNode;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  title = "Oops!",
  message = "Terjadi kesalahan yang tidak terduga.",
  renderError,
  className = "",
  showStackTrace = false,
  actionButton,
}) => {
  const error = useRouteError() as Error;
  const serviceName = (window as any).REACT_APP_SIGNOZ_SERVICE_NAME || 'react-app';
  const tracer = trace.getTracer(serviceName);
  const span = tracer.startSpan(serviceName + ".error");

  React.useEffect(() => {
    span.setAttribute('error.message', error.message);
    span.setAttribute('error.stack', JSON.stringify(error.stack));
    span.setAttribute('error.name', error.name);

    span.recordException(error);
    span.setStatus({ code: SpanStatusCode.ERROR, message: error.message });

    span.end();
  }, [error, span]);

  // Jika ada custom render function, gunakan itu
  if (renderError) {
    return <div className={className}>{renderError(error)}</div>;
  }

  return (
    <div role="alert" className={`error-page ${className}`}>
      <h1>{title}</h1>
      <p>{message}</p>
      <p><i>{(error as any).statusText || error.message}</i></p>
      
      {showStackTrace && error.stack && (
        <details>
          <summary>Stack Trace</summary>
          <pre>{error.stack}</pre>
        </details>
      )}
      
      {actionButton || (
        <button onClick={() => window.location.reload()}>
          Muat Ulang Halaman
        </button>
      )}
    </div>
  );
};

export default ErrorPage; 